import {FormStateEnum} from "./form-state.enum";

export class FormOptions {

  public readonly viewOnly: boolean = false;
  public readonly autoSubmit: boolean = true;
  public readonly autoCleanErrors: boolean = true;
  public readonly changeDelayTime: number = 1000;
  // Error messages are displayed for touched fields, if available
  public readonly markAllAsTouchedOnInvalidSubmit: boolean = false;
  public readonly fixedFormState: FormStateEnum | undefined;

  constructor(init?: Partial<FormOptions>) {
    Object.assign(this, init);
  }
}
